'use client';

import { useTranslations } from '@fshr/context/i18n-context';
import Button from '../button';
import { IconArrowCollapse } from '../icon';
import { cn } from '@fshr/shared-react';

type CTAElementProps = {
	isInDialog?: boolean;
	hasBedOptions?: boolean;
	isMultiRoom?: boolean;
	isCartEnabled?: boolean;
	ctaContainerClassName?: string;
	ctaClassName?: string;
	handleBedOptionsSelect?: (args: { isInDialog?: boolean } | undefined) => void;
	handleAddToCart?: (args: { isInDialog?: boolean } | undefined) => void;
	handleSelectOrBookNow?: (args: { isInDialog?: boolean } | undefined) => void;
	showExpandArrow?: boolean;
	isLastRoomSelection?: boolean;
	ppMode?: boolean;
};

export const OfferCtaComponent = ({
	isInDialog = false,
	hasBedOptions = false,
	isMultiRoom = false,
	isCartEnabled = false,
	ctaContainerClassName,
	ctaClassName,
	showExpandArrow = false,
	handleBedOptionsSelect,
	handleAddToCart,
	handleSelectOrBookNow,
	isLastRoomSelection = false,
	ppMode = false,
}: CTAElementProps) => {
	const translate = useTranslations();

	if (!handleBedOptionsSelect && !handleAddToCart && !handleSelectOrBookNow) {
		return null;
	}

	return (
		<div className={cn('flex flex-col spacing-stack-l', ctaContainerClassName)}>
			{hasBedOptions ? (
				<Button
					className={cn('w-full lg:w-auto', ctaClassName)}
					intent="filled"
					onClick={() => handleBedOptionsSelect?.({ isInDialog })}
				>
					{translate('Select Bed Options')}
					{showExpandArrow ? <IconArrowCollapse pathFill="white" /> : null}
				</Button>
			) : !isMultiRoom && isCartEnabled && !ppMode ? (
				<Button
					className={cn('w-full lg:w-auto', ctaClassName)}
					intent="filled"
					onClick={() => handleAddToCart?.({ isInDialog })}
				>
					{translate('Add to Cart')}
				</Button>
			) : (
				<Button
					className={cn('w-full lg:w-auto', ctaClassName)}
					intent="filled"
					onClick={() => handleSelectOrBookNow?.({ isInDialog })}
				>
					{translate(isMultiRoom && !isLastRoomSelection ? 'Select Room' : 'Book Now')}
				</Button>
			)}
		</div>
	);
};
